import axios from "../index"

// 接口基础路径
const rootApi = '/api_v2/production/workOrder'

/** 获取报工记录 */
export const getReportRecord = (id) => {
  return axios.get(`${rootApi}/reportRecord/${id}`)
}
/** 获取报工记录 */
export const reportRecorddelete = (params) => {
  return axios.get(`/api_v2/production/reportRecord/delete`,{params})
}
/** 打印 */
export const getRecordIdByBatchCode = (params) => {
  return axios.post(`/api_v2/production/productionOrder/getRecordIdByBatchCode`,params,)
}
/** 开工和暂停前的判断 */
export const isAssembly = (id) => {
  return axios.put(`${rootApi}/isAssembly/${id}`)
}

/** 选择完成与暂停当前工单 */
export const assemblyLineStart = (params) => {
  return axios.get(`${rootApi}/assemblyLineStart`,{params})
}

/** 暂停返回true时调的接口 */
export const assemblyLinePause = (params) => {
  return axios.get(`${rootApi}/assemblyLinePause`,{params})
}

/** 其他工单列表 */
export const otherWorkOrderInLine = (params) => {
  return axios.put(`${rootApi}/otherWorkOrderInLine/${params}`)
}

/** 点击开工按钮时调用 */
export const checkChildCraft = (params) => {
  return axios.get(`${rootApi}/checkChildCraft`,{params})
}

/** 子工单开工 */
export const startWorkingWithChildCraft = (params) => {
  return axios.get(`${rootApi}/startWorkingWithChildCraft`, {params})
}

/** MQTT测试 */
export const mqttTest = () => {
  return axios.get(`${rootApi}/mqttTest`)
}

